import type { FieldValue } from './field';

export interface ContentVariant {
    id: number;
    creativeId: number;
    fieldValues: FieldValue[];
}
